module.exports = __webpack_public_path__ + "static/pro_fct3-6b91996d60d9a9dfc678a4842afa05d7.jpg";